<template>
  <div v-if="aggsComputed.length" class="q-mt-sm course-view__category">
    <div class="text-subtitle1">
      User Ratings
      <span v-if="totalRatings">({{ totalRatings }})</span>
    </div>
    <div class="q-pb-sm">
      <div>
        <span v-for="(agg, index) in aggsComputed" :key="index" class="dp-pair">
          <span
            :class="{ 'text-bold': agg.parent, 'text-grey-8': !agg.parent }"
            >{{ agg.name }}</span
          >:
          <q-badge color="grey-3" text-color="black" class="text-no-wrap"
            ><span
              ><span :class="{ 'text-subtitle2': agg.parent }">{{
                agg.avgFormatted
              }}</span>
              / 10</span
            ></q-badge
          >
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { getCourseRatingAggsByCourseId } from "@/apis/course-rating-service";

export default {
  name: "CourseRatingSummary",
  props: {
    courseId: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      aggs: [],
      numberFormatter: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
      }),
    };
  },
  mounted() {
    this.refreshCourseRatingAggs();
  },
  computed: {
    ...mapState(["idToken"]),
    aggsComputed() {
      const aggs = this.aggs;
      const formatter = this.numberFormatter;
      const prettyAggs = aggs
        .map(agg => {
          const name = agg.name;
          const value = this.getPrettyAgg(name, aggs, formatter);

          return value;
        })
        .filter(agg => typeof agg.avg !== "undefined");

      return prettyAggs;
    },
    totalRatings() {
      if (!this.aggsComputed || !this.aggsComputed.length) {
        return 0;
      }

      return this.aggsComputed[0].count;
    },
  },
  methods: {
    refreshCourseRatingAggs() {
      const courseId = this.courseId;

      this.loading = true;

      this.fetchCourseRatingAggs(courseId)
        .then(results => {
          this.aggs = results.aggs;
        })
        .catch(error => {
          this.loadError = error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchCourseRatingAggs(courseId) {
      return getCourseRatingAggsByCourseId(courseId);
    },
    getPrettyAgg(name, aggs, formatter) {
      if (!Array.isArray(aggs)) {
        return null;
      }

      const agg = aggs.find(agg => agg.name === name);
      const avg = agg.avg;
      const count = agg.count;
      const max = agg.max;
      const avgFormatted = formatter.format(agg.avg);
      const parent = ["Course", "Experience"].includes(name);
      const output = {
        avg,
        avgFormatted,
        count,
        max,
        name,
        parent,
      };

      return output;
    },
  },
  watch: {
    idToken: {
      handler(newVal) {
        if (!newVal) {
          return;
        }

        this.refreshCourseRatingAggs();
      },
      immediate: true,
    },
    aggs() {
      this.$emit("update-total-ratings", this.totalRatings);
    },
  },
};
</script>
<style scoped>
.dp-pair {
  margin-right: 14px;
}
</style>
